import { useEffect, useState } from 'react';

import classes from './Captcha.module.css';

export default function Captcha(props) {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchHtmlSnippet = async () => {
    setLoading(true);
    try {
      const response = await fetch(props.url);
      const data = await response.text();
      setHtmlContent(data);
    } catch (error) {
      console.error('Erro ao carregar trecho HTML:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Carrega o trecho HTML assim que o componente é montado
    fetchHtmlSnippet();
  }, []);

  if (loading) return <p>Carregando campos adicionais...</p>;

  return (
    <div className="comp1-wrapper">
      {/* Injeta o HTML vindo do PHP com dangerouslySetInnerHTML */}
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
}